import { PropertiesManagementLocation } from './propertyManagementTypes';
import { GetLocationTreeResponseDto } from '../../API/property-management/dto/response/get-location-tree-response.dto';

export const PropertiesManagementDataTransformFetchLocation = (
  location: GetLocationTreeResponseDto
): PropertiesManagementLocation => {
  return {
    ...location,
    buildings: location.buildings.map((building) => {
      return {
        ...building,
        floors: location.floors
          .filter((floor) => floor.buildingId === building.id)
          .map((floor) => {
            return {
              ...floor,
              spaces: location.spaces.filter(
                (space) => space.floorId === floor.id
              ),
            };
          }),
      };
    }),
  };
};
